export default __webpack_public_path__ + "static/media/fist.cb176818.png";